import Global from './global/global.js';

class UserManagementRemember extends Global {

    constructor() {
        super();

        this.formSubmitBind();
    }

    formSubmitBind = () => {
        const form = document.querySelector('form');

        form.addEventListener('submit', async e => {
            e.preventDefault();

            const formData = new FormData(form);
            const response = await fetch(form.action, {
                method: "POST",
                body: formData,
            });

            const notification = await response.json();
            this.formatFormResponse(notification);
        });
    }
}

new UserManagementRemember();